export default "__VITE_ASSET__CxfP1tr7__"